import { BREAKPOINTS } from "../config/breakpoints";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Card from "../Generic/Card";
import Dropdown from "../Generic/Dropdown";
import ToggleSwitch from "../Generic/ToggleSwitch";
import FoodMakingService from "./Services/FoodMakingService";
import IotService from "./Services/iotService";
import { LoadingToast, UpdateToastFailed, UpdateToastSuccess, errorNotification, successNotification } from "../Generic/Notifications";
import Button from "../Generic/Button";
import { bindActionCreators } from "redux";
import { setMachineID } from "../Landing/Actions";
import * as Actions from "./Actions";
import { connect } from "react-redux";
import Loader from "../Generic/Loader";
import { isEmpty } from "../util/util";
import EmptyState from "../Generic/EmptyState";
import { formatDisplayDate } from "../util/date.util";
import { Link } from "react-router-dom";
import { AppRoutes, DashboardModules, StudioSubModules } from "../config/app.config";
import { zIndex } from "../config/zIndex";

const Page = styled.div`
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: left;
	padding: 2rem;
	gap: 1rem;
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		padding: 2rem;
	}
`;

const PageHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	margin: 0 0 0.5rem 0;
`;

const PageTitle = styled.h1`
	margin: 0;
	font-size: 1.75rem;
	font-weight: 700;
	letter-spacing: -0.02em;
	color: rgba(0, 0, 0, 0.92);
	line-height: 1.2;
`;

const PageSubtitle = styled.div`
	font-size: 0.875rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.55);
	line-height: 1.45;
`;

const SectionCard = ({ children, ...rest }) => (
	<Card
		alignItems="flex-start"
		padding="1.5rem"
		gap="1.25rem"
		width="100%"
		margin="0"
		borderRadius="16px"
		boxShadow="0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.1)"
		{...rest}>
		{children}
	</Card>
);

const CardHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	flex-wrap: wrap;
	width: 100%;
`;

const CardTitleGroup = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.75rem;
`;

const CardIcon = styled.span`
	font-family: "Material Symbols Outlined";
	font-size: 1.375rem;
	line-height: 1;
	display: inline-flex;
	color: rgba(45, 35, 66, 0.75);
`;

const CardTitle = styled.h2`
	margin: 0;
	font-size: 1.125rem;
	font-weight: 700;
	letter-spacing: -0.01em;
	color: rgba(0, 0, 0, 0.9);
	line-height: 1.3;
`;

const MenuNameChip = styled.div`
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	font-size: 0.8rem;
	font-weight: 600;
	color: rgba(45, 35, 66, 0.85);
	background: #f1f0f7;
	border-radius: 999px;
	padding: 0.35rem 0.8rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: ${(props) => props.gap};
`;

const StatusField = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	flex-wrap: wrap;
`;

const StatusLabel = styled.div`
	font-size: 0.8rem;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.5);
`;

const StatusBadge = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	font-size: 0.75rem;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	padding: 0.35rem 0.8rem;
	border-radius: 999px;
	white-space: nowrap;
`;

const SERVING_STATUS_META = {
	1: { backColor: "#dcfce7", textColor: "#166534" },
	0: { backColor: "#f3f4f6", textColor: "#374151" },
	2: { backColor: "#fef3c7", textColor: "#92400e" },
	3: { backColor: "#fee2e2", textColor: "#b91c1c" },
};

const ActionsRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	gap: 2.5rem;
	flex-wrap: wrap;
	width: 100%;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		flex-direction: column;
		align-items: stretch;
		gap: 1.25rem;
	}
`;

const ActionGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

const ActionLabel = styled.div`
	font-size: 0.8rem;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.5);
`;

const ActionControls = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		flex-direction: column;
		align-items: stretch;
		& > button {
			width: 100%;
		}
	}
`;

const DropdownWrapper = styled.div`
	width: 16rem;
	max-width: 100%;
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		width: 100%;
	}
`;

const DISH_COLUMNS = "1.6fr 1.6fr 1.2fr";

const DishHead = styled.div`
	display: grid;
	grid-template-columns: ${DISH_COLUMNS};
	align-items: center;
	width: 100%;
	padding: 0 0.75rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		display: none;
	}
`;

const DishHeadCell = styled.div`
	font-size: 0.72rem;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.45);
	padding: 0.25rem 0;
`;

const DishList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	width: 100%;
`;

const DishRow = styled.div`
	display: grid;
	grid-template-columns: ${DISH_COLUMNS};
	align-items: stretch;
	gap: 0;
	background: #fff;
	border: 1px solid rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	padding: 0.45rem 0.75rem;
	& > div:not(:first-child) {
		border-left: 1px solid rgba(0, 0, 0, 0.1);
		padding-left: 1rem;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		grid-template-columns: 1fr;
		gap: 0.6rem;
		padding: 0.75rem 1rem;
		& > div {
			border-left: none;
			padding-left: 0;
		}
		& > div:not(:first-child) {
			border-top: 1px solid rgba(0, 0, 0, 0.1);
			padding-top: 0.6rem;
		}
	}
`;

const Cell = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	min-width: 0;
`;

const CellLabel = styled.span`
	display: none;
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.45);
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		display: block;
	}
`;

const CellValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.15rem;
	font-size: 0.875rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.85);
	word-break: break-word;
`;

const DishEmpty = styled.div`
	font-size: 0.875rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.5);
	padding: 0.25rem 0;
`;

const SubMenuGroup = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
	width: 100%;
`;

const SubMenuHeading = styled.div`
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.88);
	line-height: 1.4;
`;

const SubMenuCount = styled.span`
	display: inline-flex;
	align-items: center;
	font-size: 0.72rem;
	font-weight: 600;
	letter-spacing: 0.03em;
	color: rgba(0, 0, 0, 0.55);
	background: rgba(0, 0, 0, 0.06);
	border-radius: 999px;
	padding: 0.15rem 0.6rem;
	white-space: nowrap;
`;

const SubMenuDescriptionText = styled.div`
	font-size: 0.875rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.52);
	line-height: 1.45;
`;

const SubMenuEmpty = styled.div`
	font-size: 0.9rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.55);
`;

const SubMenuDivider = styled.div`
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	width: 100%;
	margin: 0.25rem 0;
`;

const Pagelink = styled(Link).attrs({
	target: "_blank",
	rel: "noopener noreferrer",
})`
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
	color: #1565c0 !important;
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.1);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

const SectionDivider = styled.div`
	border-top: 1px solid rgba(0, 0, 0, 0.14);
	width: 100%;
	margin: 0.25rem 0;
`;

const COMPONENTS = {
	PAGE: "PAGE",
	RESTAURANT_STATUS: "RESTAURANT_STATUS",
	RESTAURANT_UPDATE: "RESTAURANT_UPDATE",
	NOTIFICATIONS_STATUS: "NOTIFICATIONS_STATUS",
	LIVE_MENU: "LIVE_MENU",
};

const COMPONENT_STATES = {
	LOADING: "LOADING",
	ERROR: "ERROR",
	OK: "OK",
};

const INITIAL_COMPONENT_STATES = {
	[COMPONENTS.PAGE]: COMPONENT_STATES.OK,
	[COMPONENTS.RESTAURANT_STATUS]: COMPONENT_STATES.LOADING,
	[COMPONENTS.RESTAURANT_UPDATE]: COMPONENT_STATES.OK,
	[COMPONENTS.NOTIFICATIONS_STATUS]: COMPONENT_STATES.LOADING,
	[COMPONENTS.LIVE_MENU]: COMPONENT_STATES.LOADING,
};

/** Hour:minute only for schedule range display */
const SCHEDULE_TIME_FORMAT = "HH:mm";

function formatScheduleRange(startDate, endDate) {
	const start = formatDisplayDate(startDate, SCHEDULE_TIME_FORMAT);
	const end = formatDisplayDate(endDate, SCHEDULE_TIME_FORMAT);
	if (start === "-" || end === "-") {
		return "-";
	}
	return `${start} to ${end}`;
}

// Backend stores schedule time as {h, m}; convert to a Date so the existing
// formatScheduleRange helper can render it via formatDisplayDate.
function timeToDate(time) {
	if (!time || typeof time.h !== "number" || typeof time.m !== "number") {
		return null;
	}
	const date = new Date();
	date.setHours(time.h, time.m, 0, 0);
	return date;
}

function transformMenuData(menuResponse) {
	const menuData = menuResponse?.menuData ?? {};
	const recipeIdNameMap = menuResponse?.recipeIdNameMap ?? {};
	const dishNameMap = menuResponse?.dishNameMap ?? {};
	const dishesMap = menuData?.dishes ?? {};
	const servingSchedules = menuData?.servingSchedules ?? {};
	const subMenus = Array.isArray(menuData?.subMenus) ? menuData.subMenus : [];

	const transformedSubMenus = subMenus.map((subMenu) => {
		const dishIds = Array.isArray(subMenu?.dishIds) ? subMenu.dishIds : [];
		const dishes = dishIds.map((dishId) => {
			const dish = dishesMap?.[dishId] ?? {};
			const schedule = servingSchedules?.[dish?.servingScheduleId];
			const firstSlot = schedule?.schedules?.[0]?.timeSlots?.[0];
			return {
				dishId,
				dishName: dishNameMap?.[dishId] ?? "-",
				recipeId: dish?.recipeId,
				recipeName: recipeIdNameMap?.[dish?.recipeId] ?? "-",
				startDate: timeToDate(firstSlot?.start),
				endDate: timeToDate(firstSlot?.end),
			};
		});
		return {
			name: subMenu?.name,
			description: subMenu?.description,
			dishes,
		};
	});

	return { name: menuData?.name, subMenus: transformedSubMenus };
}

const FoodMaking = (props) => {
	//States and Functions of Redux declared for use
	const { machineID, kitchenId, restaurant, setRestaurantData, RestaurantServingStatusesMap, RestaurantServingStatuses } = props;
	const [restoStateToSet, setRestoStateToSet] = useState(null);
	const [notificationsData, setNotificationsData] = useState(null);
	const [liveMenu, setLiveMenu] = useState(null);
	const [componentStates, changeComponentStates] = useState(INITIAL_COMPONENT_STATES);
	const restaurantStatusOptions = RestaurantServingStatuses ? Object.entries(RestaurantServingStatuses).map((item) => ({
		head: item[0],
		value: item[1],
	})) : [];

	async function updateResturantStatus() {
		if (restoStateToSet === null) {
			errorNotification("No restaurant status selected");
			return;
		}
		changeComponentStates((prev) => ({ ...prev, [COMPONENTS.PAGE]: COMPONENT_STATES.LOADING }));
		const { data, error } = await FoodMakingService.changeRestaurantServingStatus(machineID, { servingStatus: restoStateToSet });
		changeComponentStates((prev) => ({ ...prev, [COMPONENTS.PAGE]: COMPONENT_STATES.OK }));
		if (data) {
			const { erroredRestaurants } = data || {};
			if (isEmpty(erroredRestaurants)) {
				successNotification(`Restaurant Status set to ${RestaurantServingStatusesMap[restoStateToSet]}`);
				setRestoStateToSet(null);
				getRestaurantStatus(true);
			} else {
				const { activeOrders } = erroredRestaurants?.[machineID] || {}
				if (activeOrders) {
					errorNotification(`Could not change Restaurant Status to ${RestaurantServingStatusesMap[restoStateToSet]} as the Restaurant has Active Orders`);
				} else {
					errorNotification(`Could not change Restaurant Status to ${RestaurantServingStatusesMap[restoStateToSet]}`);
				}
			}
		}
		if (error) {
			errorNotification(error);
		}
	}

	async function sendPrimePrepareTask() {
		const PrimePrepareTask = "prime_prepare";
		const toastId = LoadingToast(`Sending Prime Prepare Task`);
		const { data, error } = await IotService.sendTask(kitchenId, machineID, PrimePrepareTask);
		if (data) {
			UpdateToastSuccess('Prime Prepare task sent', toastId);
		}
		if (error) {
			UpdateToastFailed('Prime Prepare task failed to send', toastId);
		}
	}

	async function getRestaurantStatus(handleLoading = false) {
		if (handleLoading) changeComponentStates((prev) => ({ ...prev, [COMPONENTS.RESTAURANT_STATUS]: COMPONENT_STATES.LOADING }));
		const { data, error } = await FoodMakingService.getRestaurantData(machineID);
		if (handleLoading) changeComponentStates((prev) => ({ ...prev, [COMPONENTS.RESTAURANT_STATUS]: COMPONENT_STATES.OK }));
		if (data) {
			setRestaurantData({ ...data })
		}
		if (error) {
			changeComponentStates((prev) => ({ ...prev, [COMPONENTS.RESTAURANT_STATUS]: COMPONENT_STATES.ERROR }));
			errorNotification(error);
		}
	}

	async function getLiveMenu(handleLoading = false) {
		if (handleLoading) changeComponentStates((prev) => ({ ...prev, [COMPONENTS.LIVE_MENU]: COMPONENT_STATES.LOADING }));
		const { data, error } = await FoodMakingService.getMenuData(machineID);
		if (data) {
			setLiveMenu(transformMenuData(data));
			changeComponentStates((prev) => ({ ...prev, [COMPONENTS.LIVE_MENU]: COMPONENT_STATES.OK }));
		}
		if (error) {
			changeComponentStates((prev) => ({ ...prev, [COMPONENTS.LIVE_MENU]: COMPONENT_STATES.ERROR }));
		}
	}

	async function getNotificationsStatusForRestaurant(handleLoading = false) {
		if (handleLoading) changeComponentStates((prev) => ({ ...prev, [COMPONENTS.NOTIFICATIONS_STATUS]: COMPONENT_STATES.LOADING }));
		const { data, error } = await FoodMakingService.getNotificationsStatus(machineID);
		if (handleLoading) changeComponentStates((prev) => ({ ...prev, [COMPONENTS.NOTIFICATIONS_STATUS]: COMPONENT_STATES.OK }));
		if (data) {
			setNotificationsData({ ...data });
		}
		if (error) {
			changeComponentStates((prev) => ({ ...prev, [COMPONENTS.NOTIFICATIONS_STATUS]: COMPONENT_STATES.ERROR }));
		}
	}

	async function updateNotificationsStatus(notificationStatus = false) {
		const { data, error } = await FoodMakingService.updateNotificationsStatus(machineID, { notificationStatus });
		if (data) {
			successNotification(notificationStatus ? "Notifications enabled" : "Notifications disabled");
			setNotificationsData((prev) => ({ ...prev, ...data }));
			return true;
		}
		if (error) {
			errorNotification(error);
			return false;
		}
		return false;
	}

	useEffect(() => {
		getRestaurantStatus(true);
		getNotificationsStatusForRestaurant(true);
		getLiveMenu(true);
	}, []);

	function renderRestaurantStatus(data, componentState) {
		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				return (
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);

			case COMPONENT_STATES.ERROR:
				return (
					<EmptyState
						message="Failed to load restaurant status"
						retryButtonText="Retry"
						retry={() => getRestaurantStatus(true)}
					/>
				);

			case COMPONENT_STATES.OK: {
				const servingStatus = RestaurantServingStatusesMap?.[data?.servingStatus] || "-";
				const statusMeta = SERVING_STATUS_META[data?.servingStatus] || {
					backColor: "#e5e7eb",
					textColor: "#374151",
				};
				return (
					<StatusField>
						<StatusLabel>Serving Status</StatusLabel>
						<StatusBadge background={statusMeta.backColor} color={statusMeta.textColor}>
							{servingStatus}
						</StatusBadge>
					</StatusField>
				);
			}

			default:
				return null;
		}
	}

	function renderNotificationsStatus(componentState) {
		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				return (
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);

			case COMPONENT_STATES.ERROR:
				return (
					<EmptyState
						message="Failed to load notifications status"
						retryButtonText="Retry"
						retry={() => getNotificationsStatusForRestaurant(true)}
					/>
				);

			case COMPONENT_STATES.OK:
				return (
					<ToggleSwitch
						title="Notifications"
						initialStatus={notificationsData?.notificationStatus ?? false}
						onChange={async (newStatus) => updateNotificationsStatus(newStatus)}
						isAsync={true}
					/>
				);

			default:
				return null;
		}
	}

	function renderLiveMenu(liveMenu, componentState) {
		const subMenus = liveMenu?.subMenus ?? [];

		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				return (
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);

			case COMPONENT_STATES.ERROR:
				return (
					<EmptyState
						message="Failed to fetch live menu"
						retryButtonText="Retry"
						retry={() => getLiveMenu(true)}
					/>
				);

			case COMPONENT_STATES.OK:
				if (subMenus.length === 0) {
					return <SubMenuEmpty>No submenus found for this menu.</SubMenuEmpty>;
				}
				return subMenus.map((subMenu, index) => (
					<SubMenuGroup
						key={subMenu.name ? `${subMenu.name}-${index}` : `submenu-${index}`}>
						{index > 0 ? <SubMenuDivider /> : null}
						<Row gap="0.75rem">
							<SubMenuHeading>{subMenu.name ?? "-"}</SubMenuHeading>
							{subMenu?.dishes?.length ? <SubMenuCount>{subMenu.dishes.length} dishes</SubMenuCount> : null}
						</Row>
						<SubMenuDescriptionText>{subMenu.description ?? "-"}</SubMenuDescriptionText>
						{subMenu?.dishes?.length ? (
							<>
								<DishHead>
									<DishHeadCell>Dish Name</DishHeadCell>
									<DishHeadCell>Recipe Name</DishHeadCell>
									<DishHeadCell>Schedule</DishHeadCell>
								</DishHead>
								<DishList>
									{subMenu.dishes.map((dish, dishIndex) => (
										<DishRow
											key={dish.dishId != null ? `${dish.dishId}-${dishIndex}` : dish.dishName ? `${dish.dishName}-${dishIndex}` : `dish-${dishIndex}`}>
											<Cell>
												<CellLabel>Dish Name</CellLabel>
												<CellValue>
													{dish.dishName ?? "-"}
													{dish.dishId ? (
														<Pagelink
															to={AppRoutes[DashboardModules.STUDIO][StudioSubModules.DISH].DISH_DETAILS.getPath(dish.dishId)}>
															View Dish
														</Pagelink>
													) : null}
												</CellValue>
											</Cell>
											<Cell>
												<CellLabel>Recipe Name</CellLabel>
												<CellValue>
													{dish.recipeName ?? "-"}
													{dish.recipeId ? (
														<Pagelink
															to={AppRoutes[DashboardModules.STUDIO][StudioSubModules.RECIPE].RECIPE_DETAILS.getPath(dish.recipeId)}>
															View recipe
														</Pagelink>
													) : null}
												</CellValue>
											</Cell>
											<Cell>
												<CellLabel>Schedule</CellLabel>
												<CellValue>{formatScheduleRange(dish.startDate, dish.endDate)}</CellValue>
											</Cell>
										</DishRow>
									))}
								</DishList>
							</>
						) : (
							<DishEmpty>No dishes</DishEmpty>
						)}
					</SubMenuGroup>
				));

			default:
				return null;
		}
	}

	return (
		<Page>
			{componentStates[COMPONENTS.PAGE] === COMPONENT_STATES.LOADING ? <Overlay /> : ""}

			<PageHeader>
				<PageTitle>Restaurant Data</PageTitle>
				<PageSubtitle>
					Manage serving status, kitchen actions, feature flags and the live menu for machine {machineID ?? "-"}.
				</PageSubtitle>
			</PageHeader>

			<SectionCard>
				<CardHeader>
					<CardTitleGroup>
						<CardIcon>storefront</CardIcon>
						<CardTitle>Restaurant Status</CardTitle>
					</CardTitleGroup>
				</CardHeader>
				{renderRestaurantStatus(restaurant, componentStates[COMPONENTS.RESTAURANT_STATUS])}
			</SectionCard>

			<SectionDivider />

			<SectionCard>
				<CardHeader>
					<CardTitleGroup>
						<CardIcon>bolt</CardIcon>
						<CardTitle>Actions</CardTitle>
					</CardTitleGroup>
				</CardHeader>
				<ActionsRow>
					<ActionGroup>
						<ActionLabel>Set Serving State</ActionLabel>
						<ActionControls>
							<DropdownWrapper>
								<Dropdown
									widthVal="100%"
									margin="0"
									head="Select a status"
									optionsList={restaurantStatusOptions}
									value={restoStateToSet}
									onChange={setRestoStateToSet}
								/>
							</DropdownWrapper>
							<Button active onClick={updateResturantStatus}>Apply</Button>
						</ActionControls>
					</ActionGroup>
					<ActionGroup>
						<ActionLabel>Kitchen</ActionLabel>
						<ActionControls>
							<Button onClick={sendPrimePrepareTask}>Prime Prepare</Button>
						</ActionControls>
					</ActionGroup>
				</ActionsRow>
			</SectionCard>

			<SectionDivider />

			<SectionCard>
				<CardHeader>
					<CardTitleGroup>
						<CardIcon>flag</CardIcon>
						<CardTitle>Feature Flags</CardTitle>
					</CardTitleGroup>
				</CardHeader>
				{renderNotificationsStatus(componentStates[COMPONENTS.NOTIFICATIONS_STATUS])}
			</SectionCard>

			<SectionDivider />

			<SectionCard gap="1rem">
				<CardHeader>
					<CardTitleGroup>
						<CardIcon>restaurant_menu</CardIcon>
						<CardTitle>Live Menu</CardTitle>
					</CardTitleGroup>
					{liveMenu?.name ? <MenuNameChip>{liveMenu.name}</MenuNameChip> : null}
				</CardHeader>
				{renderLiveMenu(liveMenu, componentStates[COMPONENTS.LIVE_MENU])}
			</SectionCard>
		</Page>
	);
};

const mapStatetoProps = (state) => {
	const { foodmaking, landing } = state;
	return {
		machineID: landing.machineID,
		kitchenId: landing.kitchenId,
		...foodmaking,
	};
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			setMachineID: setMachineID,
			...Actions,
		},
		dispatch
	),
});

export default connect(mapStatetoProps, mapDispatchToProps)(FoodMaking);
